import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    Chip,
    useTheme,
    useMediaQuery,
    ButtonGroup,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Grid,
    CircularProgress,
    Tabs,
    Tab,
    Autocomplete,
    Menu,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import {
    Close as CloseIcon,
    Add as AddIcon,
    Person as PersonIcon,
    CalendarMonth as CalendarIcon,
    Event as EventIcon,
    AccountCircle as AccountCircleIcon,
    DragIndicator as DragIcon,
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
    TableChart as TableIcon,
    ViewModule as KanbanIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    Polyline as PolylineIcon,
    ManageAccounts as ManageAccountsIcon,
    SupervisorAccount as SupervisorAccountIcon,
    Delete as DeleteIcon,
    Warning as WarningIcon,
    Sync as SyncIcon,
    ElectricalServices as TowerIcon,
    AccountTree as AccountTreeIcon,
    ExpandMore as ExpandMoreIcon,
    Archive as ArchiveIcon,
    Clear as ClearIcon,
    LocationOn as LocationIcon
} from '@mui/icons-material';

export const TaskDeleteConfirmDialog = ({
    taskToDelete,
    handleCancel,
    handleConfirm,
    darkMode,
    isMobile,
}) => {
    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="delete-confirm-title"
            aria-describedby="delete-confirm-description"
            maxWidth="sm"
            sx={{ zIndex: 6500 }}
            fullWidth
            disableRestoreFocus
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        color: darkMode ? '#f5f7fa' : '#333',
                    }
                }
            }}
        >
            <DialogTitle id="delete-confirm-title" sx={{
                bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                color: darkMode ? '#f5f7fa' : '#333',
                borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon sx={{ color: darkMode ? '#ff9800' : '#f57c00' }} />
                    <Typography variant="h6" component="span">
                        Подтверждение удаления
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent id="delete-confirm-description" sx={{
                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                color: darkMode ? '#f5f7fa' : '#333',
                py: 3
            }}>
                <Typography variant="body1" sx={{ mb: 2, pt: 1 }}>
                    Вы действительно хотите удалить задачу?
                </Typography>

                {taskToDelete && (
                    <Box sx={{
                        p: 2,
                        borderRadius: 1,
                        bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`
                    }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                            {taskToDelete.title || taskToDelete.name}
                        </Typography>
                        <Typography variant="caption" sx={{
                            color: darkMode ? '#888' : '#666'
                        }}>
                            ID: {taskToDelete.id}
                        </Typography>
                    </Box>
                )}


            </DialogContent>

            <DialogActions sx={{
                bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                borderTop: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`
            }}>
                <Button
                    onClick={handleCancel}
                    sx={{
                        color: darkMode ? '#f5f7fa' : '#666',
                        '&:hover': {
                            bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                        }
                    }}
                >
                    Отмена
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    sx={{
                        bgcolor: '#d32f2f',
                        '&:hover': {
                            bgcolor: '#b71c1c'
                        }
                    }}
                    startIcon={<DeleteIcon />}
                >
                    Удалить
                </Button>
            </DialogActions>
        </Dialog>
    )
}